import { create } from 'zustand';
import { Region } from '@/features/regions/types';

interface RegionStore {
  // Selected region
  selectedRegion: Region | null;
  setSelectedRegion: (region: Region | null) => void;
  
  // Create modal state
  isCreateModalOpen: boolean;
  openCreateModal: () => void;
  closeCreateModal: () => void;
  
  // Edit modal state
  isEditModalOpen: boolean;
  openEditModal: (region: Region) => void;
  closeEditModal: () => void;
  
  // Reset store state
  reset: () => void;
}

// Initial state
const initialState = {
  selectedRegion: null,
  isCreateModalOpen: false,
  isEditModalOpen: false
};

export const useRegionStore = create<RegionStore>((set) => ({
  // Initial state
  ...initialState,
  
  // Region selection
  setSelectedRegion: (region) => set({ selectedRegion: region }),
  
  // Create modal controls
  openCreateModal: () => set({ isCreateModalOpen: true }),
  closeCreateModal: () => set({ isCreateModalOpen: false }),
  
  // Edit modal controls
  openEditModal: (region) => set({ 
    selectedRegion: region,
    isEditModalOpen: true 
  }),
  closeEditModal: () => set({ 
    isEditModalOpen: false,
    // Do not clear selectedRegion here as it might be needed in other contexts
  }),
  
  // Reset function
  reset: () => set(initialState)
}));
